export const CATEGORIES = [
  { value: "Influencer", label: "Influencer" },
  { value: "Ambassador", label: "Ambassador" },
  { value: "Activity Provider", label: "Activity Provider" },
];
export const SUBSCRIPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
];

export const CATEGORIES_FILTER = [
  { value: "All", label: "Category" },
  { value: "Influencer", label: "Influencer" },
  { value: "Ambassador", label: "Ambassador", width: "120px" },
  { value: "Activity Provider", label: "Activity Provider" },
];

export const SUBSCRIPTION_FILTER = [
  { value: "All", label: "Subscription" },
  { value: "paid", label: "Paid" },
  { value: "pending", label: "Pending" },
];
